export default __webpack_public_path__ + "static/media/bannerMini3.3b0d5553.jpg";